export class StaffDialog {
    siteId: number;
    token: string;
    usersTable: any;
    allUsers: any[];
    checkedUserIds: Set<number> = new Set();

    successCallback: (response: any) => void;
    constructor(allUsersJson: any, siteId: number) {
        $(() => {
            this.allUsers = allUsersJson;
            this.siteId = siteId;
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

            this.initialize();
        })
    }

    initialize() {
        // save button
        $('#saveStaffDialogBtn').on('click', this.saveChanges);

        // users table
        $('#edit-staff-table').on('change', '.assign-checkbox', (e) => {
            const checkbox = e.currentTarget as HTMLInputElement;
            const rawId = checkbox.dataset.id;
            const id = Number(checkbox.dataset.id);

            if (checkbox.checked) {
                this.checkedUserIds.add(id);
            } else {
                this.checkedUserIds.delete(id);
            }
        });

        this.usersTable = $('#edit-staff-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh', // adjust?
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: (_data, _type, row) => {
                        const userId = Number(row.Id);
                        return `<input type="checkbox" class="assign-checkbox" data-id="${userId}" />`;
                    }
                },
                { data: "Name", title: "Name", className: '' },
                { data: 'RoleName', title: 'Role', className: '' },
            ],
            data: this.allUsers,
            rowCallback: (row, data: any) => {
                const userId = Number(data.Id);
                $(row)
                    .find<HTMLInputElement>(".assign-checkbox")
                    .prop("checked", this.checkedUserIds.has(userId));
            },
        });

        // search box
        $("#edit-staff-search").on('input', (e) => {
            $("#edit-staff-table").DataTable().search(String($(e.target).val() ?? '')).draw();
        })

        $("#edit-staff-search-clear").on('click', (e) => {
            $("#edit-staff-search").val('');
            $("#edit-staff-table").DataTable().search('').draw();
        })

        $('#editStaffDialog').on('shown.bs.modal', () => {
            if (this.usersTable) {
                this.usersTable.columns.adjust();
            }
        });
    }
    
    populateCheckedUsers(users: any[]): void {
        this.checkedUserIds.clear();

        if (Array.isArray(users)) {
            for (const u of users) {
                this.checkedUserIds.add(Number(u.Id));
            }
        }

        if (this.usersTable) {
            this.usersTable.draw(false);
        }
    }

    saveChanges = () => {
        $('#saveStaffDialogBtn').prop('disabled', true);
        $('#staffSaveSpinner').show();

        const assignedStaff = Array.from(this.checkedUserIds);
        const formData = new FormData();

        formData.append('Id', String(this.siteId));
        formData.append('AssignedUsers', JSON.stringify(assignedStaff));
        $.ajax({
            url: `/secure/ctms/sites/site-details?handler=UpdateUsers`,
            method: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            headers: { "RequestVerificationToken": this.token },
            success: (response) => {
                $('#editStaffDialog').modal('hide');
                if (this.successCallback) this.successCallback(response);
            },
            error: function (xhr) {
                alert('Error saving changes to assigned staff.');
            }
        }).always(function () {
            $('#saveStaffDialogBtn').prop('disabled', false);
            $('#staffSaveSpinner').hide();
        })
    }
}